import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { View, StyleSheet, Animated, Easing } from 'react-native';
import {
    JDTouchableWithoutFeedback, JDImage, JDText
} from '@jdreact/jdreact-core-lib';

import { pt, jumpByUrl, formatJumpUrl, sendClickDataWithJsonParam } from '../../../components/utiles';

export default class Banner extends PureComponent {
    static defaultProps = {
        onBeforeJump: () => {},
        itemTextStyle: {},
        bannerList: [],
        limitNum: 100
    }

    constructor(props) {
        super(props);
        this.state = {
        };
    }

    componentDidMount() {

    }
    _jumpToWeb(item = {},itemIndex) {
        const {
            onBeforeJump
        } = this.props;
        const {
            jumpUrl
        } = item;

        sendClickDataWithJsonParam({
            event_id: 'OfficeBuilding_Icon',
            page_id: this.props.pageId,
            json_param: {
                icon_name: item.title,
                linkUrl: jumpUrl,
                icon_position: itemIndex + ''
            },
        })
        
        if (onBeforeJump && typeof onBeforeJump === 'function') {
            onBeforeJump();
        }
        if (jumpUrl) {
            jumpByUrl(jumpUrl);
        }
    }
    render() {
        const {
            bannerList,
            itemTextStyle,
            limitNum
        } = this.props;
        return (
            <View style={st.bannerBox} >
                {
                   bannerList.map((item, itemIndex) => {
                        return (
                            itemIndex < limitNum ? <View key={itemIndex + '_banner'} style={[st.banner_itemBox]}>
                                <JDTouchableWithoutFeedback onPress={() => this._jumpToWeb(item, itemIndex)}>
                                    <View style={st.banner_itemiBox}>
                                        <View style={st.banner_itemiconBox}>
                                            <JDImage style={[st.banner_itemicon]} source={{ uri: formatJumpUrl(item.imgUrl) }} resizeMode='contain' />
                                        </View>
                                        <View style={[st.itemTextWrap]}>
                                            <JDText style={[st.banner_itemText,itemTextStyle]}>{item.title}</JDText>
                                        </View>
                                    </View>
                                </JDTouchableWithoutFeedback>
                            </View> : null
                        );
                    })
                }
            </View>
        );
    }
}

Banner.propTypes = {
    itemTextStyle: PropTypes.object,
    bannerList: PropTypes.array,
    limitNum: PropTypes.number,
    onBeforeJump: PropTypes.func
};
const st = StyleSheet.create({
    bannerBox: {
        backgroundColor: '#ffffff',
        flexDirection: 'row',
        justifyContent: 'space-around',
        alignItems: 'center'
    },
    banner_itemBox: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
    },
    banner_itemiBox: {
        alignItems: 'center',
        justifyContent: 'center',
    },
    banner_itemiconBox: {
        width: pt(60),
        height: pt(60),
        marginBottom: pt(25)
    },
    banner_itemicon: {
        width: pt(60),
        height: pt(60)
    },
    itemTextWrap: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center'
    },
    
    banner_itemText: {
        textAlign: 'center',
        fontSize: pt(24),
        color: '#262626'
    },
});
